import { Box } from '@mui/material';
import Image from 'next/image';
import Slider from '@/components/Slider';
import { Banner } from '@/types/models';
import { VideoPlayer } from '@/components/VideoPlayer';
type PDPBannerProps = {
  items: Banner[];
};
const PDPBanner = ({
  items = []
}: PDPBannerProps): JSX.Element | undefined => {
  return <Slider data={items} pagination={true} navigation={true} allowTouchMove={false} customComponent={item => <Box sx={{
    borderRadius: {
      md: 'var(--corner_radius_m)'
    },
    width: '100%',
    minHeight: {
      xs: 220,
      md: 445
    },
    height: '100%',
    '& .video-js': {
      borderRadius: {
        md: 'var(--corner_radius_m)'
      },
      minHeight: {
        xs: 220,
        md: 445
      }
    }
  }}>
          {item.extension === 'mp4' || item.extension === 'mkv' ? <VideoPlayer src={item.url} /> : <Image src={item?.url.toString()} alt={item?.id.toString() || ''} sizes='100vw' style={{
      // width: '100%',
      // height: 'auto',
      // maxHeight: 445,
      objectFit: 'cover',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }} width={795} height={445} />}
        </Box>} data-sentry-element="Slider" data-sentry-component="PDPBanner" data-sentry-source-file="PDPBanner.tsx" />;
};
export default PDPBanner;